var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-tabs',{staticClass:"simple-tabs group-tabs",attrs:{"content-class":"simple-tabs-body p-t-30 min-height-300px","active-tab-class":"primary-bg"}},[_c('b-tab',{attrs:{"title":_vm.$t('statements.accounting.title'),"active":""}},[_c('StatementsAccounting')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }